import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Label, FormGroup, Form, Input, Row, Col} from 'reactstrap';
import FormWrapper from './../../commonComponents/formWrapper/FormWrapper.container';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import _ from 'lodash';
import './NotificationSettings.css';
import NotificationsLanguageSelector from './../../languageSelector/NotificationsLanguageSelector.container';

const PREFERRED_LANGUAGE = 'preferredLanguage';

class NotificationSettings extends Component {
    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onUnmount();
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isNil(nextProps.data) && !_.isEqual(this.state, nextProps.data) && !nextProps.loading) {
            this.setState({...nextProps.data});
        }
    }

    render() {
        return (
            <div className="notification-settings-container">
                <FormWrapper
                    successMessage={_.get(this.props.translation, 'notification_settings.notification_settings_update_success_alert')}>
                    <Form onSubmit={this.onSubmit}>
                        <h5 className="text-center notification-settings-label">{_.get(this.props.translation, 'notification_settings.notification_settings_label')}</h5>
                        {this.renderContent()}
                    </Form>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading && _.isNil(this.props.data)) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
            )
        }

        if (_.isEmpty(this.props.data)) {
            return (
                <h6 className="text-center">{_.get(this.props.translation, 'notification_settings.no_settings_label')}</h6>
            )
        }

        return (
            <div>
                <div className='notification-settings-form-groups-container'>
                    {this.renderData()}
                </div>
                <div className="button-container">
                    <Button className="olive-green-btn" disabled={this.saveButtonDisabled()}
                            type="submit">{_.get(this.props.translation, sharedLabelsPath.save_changes_button)}</Button>
                </div>
            </div>
        );
    };

    saveButtonDisabled = () => {
        return _.isNil(this.props.data) ||
            _.every(this.props.data, (value, key) => this.state.hasOwnProperty(key) ? this.state[key] === value : true);
    };

    renderData = () => {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return [
            ..._.chain(this.state)
                .mapValues(this.getFormGroup)
                .values()
                .value()
        ];
    };

    getFormGroup = (value, key) => {
        let id = _.kebabCase(key);
        let label = _.snakeCase(key);

        if (key === PREFERRED_LANGUAGE) {
            return (<FormGroup key={id} className='notification-settings-checkbox-group'>
                <Row>
                    <Col className='preferred-language-label'>
                        {_.get(this.props.translation, 'notification_settings.' + label)}:
                    </Col>
                    <Col>
                        <NotificationsLanguageSelector className='notifications-language-selector'
                                                       key={id}
                                                       selectedLanguage={this.state[PREFERRED_LANGUAGE]}
                                                       onLanguageSelect={this.handleLanguageSelect}/>
                    </Col>
                </Row>
            </FormGroup>);
        }

        return (
            <FormGroup key={id} className='notification-settings-checkbox-group'>
                <Row className='checkbox-container'>
                    <Label className='checkbox-label'>
                        <Input
                            type="checkbox"
                            checked={value}
                            onChange={this.handleChange(key)}
                        />
                        {_.get(this.props.translation, 'notification_settings.' + label)}
                    </Label>
                </Row>
            </FormGroup>
        );
    };

    handleLanguageSelect = (language) => {
        this.setState({[PREFERRED_LANGUAGE]: language});
    };

    handleChange = (fieldKey) => () => {
        this.setState({[fieldKey]: !this.state[fieldKey]});
    };

    onSubmit = (e) => {
        e.preventDefault();

        let data = {
            ...this.state
        };

        this.props.onUserSettingsUpdate(data);
    };
}

NotificationSettings.propTypes = {
    data: PropTypes.object,
    loading: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onMount: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
    onUserSettingsUpdate: PropTypes.func.isRequired
};

export default NotificationSettings;



// WEBPACK FOOTER //
// ./src/components/accountManagement/notificationSettings/NotificationSettings.js